var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggregateAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5312 3.0625C11.8125 3.34375 12 3.75 12 4.125V14.5312C12 15.3438 11.3125 16 10.5 16H1.46875C0.65625 16 0 15.3438 0 14.5312V1.53125C0 0.6875 0.65625 0.03125 1.46875 0H7.875C8.25 0 8.65625 0.1875 8.9375 0.46875L11.5312 3.0625ZM8 1.03125V4.03125H10.9688C10.9375 3.9375 10.9062 3.84375 10.8438 3.78125L8.21875 1.15625C8.15625 1.09375 8.0625 1.0625 8 1.03125ZM11 14.5312V5H7.75C7.3125 5 7 4.6875 7 4.28125V1H1.46875C1.21875 1 0.96875 1.25 0.96875 1.53125V14.5312C0.96875 14.7812 1.21875 15.0312 1.46875 15.0312H10.5C10.75 15.0312 11 14.7812 11 14.5312ZM6 6C8.1875 6.03125 9.96875 7.8125 9.96875 10C9.96875 10 10 10 9.96875 10H6V6ZM7 7.1875V9H8.8125C8.5 8.15625 7.84375 7.5 7 7.1875ZM5.5 13C6.6875 13 7.6875 12.1562 7.9375 11H8.9375C8.6875 12.7188 7.25 14 5.5 14C3.5625 14 2 12.4375 2 10.5C2 8.75 3.28125 7.3125 5 7.0625V8.0625C3.84375 8.3125 3 9.3125 3 10.5C3 11.9062 4.09375 13 5.5 13Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggregateAverage);
export default __webpack_public_path__ + "static/media/aggregate_average.5265f958.svg";
export { ForwardRef as ReactComponent };